import type { API } from 'types/frontend/shared';

export const DO_AUTHORIZE_SSE = (academyId: number, category: string): API => ({
  method: 'POST',
  path: `/academy/${academyId}/sse/${category}/authorize`,
});

export const SSE_STREAM = (academyId: number, category: string): string =>
  `/academy/${academyId}/sse/${category}/stream`;
